import logo from "@/assets/logo/logo-icon.png";
import TextLogo from "@/assets/logo/text-logo.png";
import { useGetMeQuery } from "@/redux/feature/user/userApi";
import { useAppDispatch, useAppSelector } from "@/redux/hooks/hooks";
import { SideBarLinkProps, TUser } from "@/types/types";
import IncoiveIcon from "@/assets/icons/Invoices.svg";
import AcountSettngIcon from "@/assets/icons/AcountSettingIcon.svg";
import BillingSettingIcon from "@/assets/icons/BillinSettingIcons.svg";
import Question from "@/assets/icons/Question.svg";
import { Link, useLocation } from "react-router-dom";
import SignOutIcon from "@/assets/icons/LogoutIcon.svg";
import { logOut } from "@/redux/feature/auth/authSlice";
import { useEffect, useState } from "react";
import { setShowMobileSideBar } from "@/redux/feature/global/globalSlice";
import ActiveIcon from "@/assets/icons/ActiveUserIcon.svg";
import NotificationsIcon from "@/assets/icons/Notification.svg";
import MessagesIcon from "@/assets/icons/Messages.svg";
import { useNotifications } from "@/context/NotificationContext";

const MobileSideBarItems = [
  {
    label: "Account Settings",
    icon: <AcountSettngIcon />,
    path: "/profile",
  },
  {
    label: "Notification",
    icon: <NotificationsIcon />,
    path: "/notification",
  },

  {
    icon: <MessagesIcon />,
    element: <MessagingDashboard />,
    label: "Messages",
    id: "messages",
    path: "messages",
  },
  // {
  //   label: "Billing Settings",
  //   icon: <BillingSettingIcon />,
  //   path: "/billing-settings",
  // },
  // { icon: <Question />, label: "Help and Feedback", path: "/help" },
];
import { useNavigate } from "react-router-dom";
import { MessagingDashboard } from "@/pages/messaging/MessagingDashboard";

const MobileSideBar = () => {
  const { showMobileSideBar } = useAppSelector((state) => state.global);
  const { user } = useAppSelector((state) => state.auth);
  const { data } = useGetMeQuery(user?.email);
  const userData: TUser | undefined = data?.data;
  const location = useLocation();
  const dispatch = useAppDispatch();

  const pathname = location.pathname;
  const navigate = useNavigate();
  const { totalUnreadNotifications } = useNotifications();
  const unreadCount = Number(totalUnreadNotifications) || 0;
  const handleLogout = () => {
    dispatch(logOut());
    navigate("/auth/sign-in");
  };

  // User name slice based on name
  const getInitials = (fullName: string) => {
    const nameParts = fullName.split(" ");
    if (nameParts.length > 1) {
      return (
        nameParts[0].slice(0, 1) + nameParts[nameParts.length - 1].slice(0, 1)
      );
    }
    return nameParts[0].slice(0, 1);
  };

  const splitUserName = userData?.fullName
    ? getInitials(userData.fullName)
    : "";

  return (
    <div>
      {/* Sidebar Container */}
      <div
        className={`bg-white absolute ${
          showMobileSideBar ? "-left-[0px]" : "-left-[400px]"
        } transition-all duration-300 ease-in-out z-50 pt-[50px] h-full min-w-[290px] rounded-r-[16px] pb-7 flex flex-col`}
      >
        {/* Logo Section */}
        <div className="flex items-center gap-x-2 cursor-pointer px-6 mb-10">
          <img src={logo} alt="passionbits-logo" />
          <img src={TextLogo} alt="text-logo" />
        </div>

        {/* User Profile Section */}
        <div className="mb-5 px-6">
          <div>
            {userData?.profilePicture ? (
              <div className="relative">
                <img
                  className="w-14"
                  src={userData.profilePicture}
                  alt="profile"
                />
                {/* <div className="absolute bottom-[0px] right-[0px]">
                  <ActiveIcon />
                </div> */}
              </div>
            ) : (
              <div className="size-10 flex justify-center items-center text-[#17457D] rounded-full text-sm font-semibold leading-5 relative bg-[#17457D0F]">
                {splitUserName}
                <div className="absolute bottom-[0px] right-[0px]">
                  <ActiveIcon />
                </div>
              </div>
            )}
          </div>
          <p className="font-semibold pt-2 pb-1 text-body-regular">
            {userData?.fullName}
          </p>
          <p className="font-medium text-[#667085] text-caption2-regular">
            {userData?.email}
          </p>
        </div>

        {/* Sidebar Links */}
        <div>
          <ul className="space-y-[2px] px-3">
            {MobileSideBarItems.map((item, i) => (
              <MobileSideBarLink
                data={item}
                pathname={pathname}
                unreadCount={unreadCount}
                key={i}
              />
            ))}
            <button
              onClick={handleLogout}
              className="px-3.5 py-[10px] flex h-full justify-start flex-row gap-x-2 w-full items-center transform ease-in-out transition-all text-[#62636C] bg-white border-none"
            >
              <SignOutIcon />
              <p className="whitespace-nowrap transform ease-in-out transition-all duration-300 font-medium text-sm leading-5 tracking-[-0.75%]">
                Sign out
              </p>
            </button>
          </ul>
        </div>
      </div>

      {/* Overlay when sidebar is open */}
      {showMobileSideBar && (
        <div
          onClick={() => dispatch(setShowMobileSideBar(false))}
          className="absolute bg-black/50 h-full w-full left-0 top-0 z-[44]"
        ></div>
      )}
    </div>
  );
};

export default MobileSideBar;

type MobileSideBarLinkProps = SideBarLinkProps & {
  unreadCount: number;
};

const MobileSideBarLink = ({
  data,
  pathname,
  unreadCount,
}: MobileSideBarLinkProps) => {
  const dispatch = useAppDispatch();
  const isActive = pathname === data.path || pathname.includes(data.path);
  return (
    <li onClick={() => dispatch(setShowMobileSideBar(false))} className="">
      <Link to={data.path}>
        <div
          className={`${
            isActive
              ? "bg-[#FEF4ED] border border-[#FFD6B9] rounded-[6px] text-[#ED5E00]"
              : "text-[#62636C] bg-white border-none"
          }  px-3 py-[10px] flex h-full justify-start   flex-row gap-x-2 w-full items-center  transform ease-in-out transition-all`}
        >
          <div className="w-[20px]">{data.icon}</div>
          <p
            className={`opacity-100
              whitespace-nowrap transform ease-in-out  transition-all duration-300 font-medium text-sm leading-5 tracking-[-0.75%]`}
          >
            {data.label}
            {data.path === "/notification" && unreadCount > 0 && (
              <span className="flex h-5 min-w-5 items-center justify-center rounded-full bg-[#FF6600] px-1.5 text-[11px] font-semibold text-white">
                {unreadCount > 99 ? "99+" : unreadCount}
              </span>
            )}
          </p>
        </div>
      </Link>
    </li>
  );
};

// Balance indicator

interface BalanceIndicatorProps {
  used: number;
  total: number;
}

const BalanceIndicator = ({ used, total }: BalanceIndicatorProps) => {
  const [width, setWidth] = useState<number>(0);
  const percentage = (used / total) * 100;

  useEffect(() => {
    setWidth(0);
    const timer = setTimeout(() => setWidth(percentage), 50);
    return () => clearTimeout(timer);
  }, [used, total, percentage]);

  return (
    <div>
      <div className="h-2 bg-[#00336621] rounded-full overflow-hidden mb-3">
        <div
          className="h-full bg-[#003366] rounded-xl transition-all duration-1000 ease-out"
          style={{ width: `${width}%` }}
        ></div>
      </div>
      <p className="leading-[18px]">
        <span className="text-sm font-medium">{used}</span>{" "}
        <span className="text-xs">used out of </span>
        <span className="text-sm font-medium">{total}</span>
      </p>
    </div>
  );
};
